import React from "react";
import PropTypes from "prop-types";

const CustomPagination = ({ pagination = {}, onChange }) => {

    const current = pagination.current || 0;
    const totalPages = pagination.lastPage || 0;
    const maxPagesToShow = 5;

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages && page !== current) {
            onChange(page);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        let startPage = Math.max(current - Math.floor(maxPagesToShow / 2), 1);
        let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

        // Ajusta startPage se endPage for menor que maxPagesToShow
        if (endPage - startPage + 1 < maxPagesToShow) {
            startPage = Math.max(endPage - maxPagesToShow + 1, 1);
        }

        if (startPage > 1) {
            pageNumbers.push(
                <li key={1} className="page-item">
                    <button type="button" className="page-link" onClick={() => handlePageChange(1)}>1</button>
                </li>
            );
            if (startPage > 2) {
                pageNumbers.push(
                    <li key="start-ellipsis" className="page-item disabled">
                        <span className="page-link">...</span>
                    </li>
                );
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <li key={i} className={`page-item ${i === current ? "active" : ""}`}>
                    <button type="button" className="page-link" onClick={() => handlePageChange(i)}>{i}</button>
                </li>
            );
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pageNumbers.push(
                    <li key="end-ellipsis" className="page-item disabled">
                        <span className="page-link">...</span>
                    </li>
                );
            }
            pageNumbers.push(
                <li key={totalPages} className="page-item">
                    <button className="page-link" onClick={() => handlePageChange(totalPages)}>{totalPages}</button>
                </li>
            );
        }

        return pageNumbers;
    };

    return (
        totalPages > 0 && (
            <nav aria-label="Page navigation">
                <ul className="pagination mt-3">
                    {/* Página Anterior */}
                    <li className={`page-item ${current === 1 ? "disabled" : ""}`}>
                        <button type="button" className="page-link" onClick={() => handlePageChange(current - 1)}>&laquo;</button>
                    </li>

                    {/* Números das Páginas */}
                    {renderPageNumbers()}

                    {/* Próxima Página */}
                    <li className={`page-item ${current === totalPages ? "disabled" : ""}`}>
                        <button type="button" className="page-link" onClick={() => handlePageChange(current + 1)}>&raquo;</button>
                    </li>
                </ul>
            </nav>
        )
    );
};

CustomPagination.propTypes = {
    pagination: PropTypes.shape({
        current: PropTypes.number,
        total: PropTypes.number,
        perPage: PropTypes.number,
        lastPage: PropTypes.number
    }),
    onChange: PropTypes.func.isRequired,
};

export default CustomPagination;
